export const formatDateOnly = (dateString: string): string => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Fecha no disponible';
  
  // Mostrar exactamente la hora UTC como está en PostgreSQL
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');
  
  return `${day}/${month}/${year}`;
};

export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Fecha no disponible';
  
  // Mostrar exactamente la hora UTC como está en PostgreSQL
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  
  return `${day}/${month}/${year}, ${hours}:${minutes}`;
};